import { ErrorManagement } from '@printdeal/error-management/react';
import Api from '../Api';

interface File {
  [key: string]: {
    originalSourceUrl: string;
    previewUrl: string;
    fileName: string;
  }
}

class PrintQService extends Api {
  async getUploadedFiles(docRef: string): Promise<File | null> {
    try {
      const params = new URLSearchParams();
      params.append('docRef', docRef);
      const { data: { data } } = await this.httpClient.get<{ data: File }>(`getUploadedFiles?${params}`);

      return data;
    } catch (error) {
      ErrorManagement.exception({
        exception: error,
        fingerprint: ['printq-service-get-uploaded-files'],
      });
    }
    return null;
  }
}

export default PrintQService;
